import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

const NAV_ITEMS = [
  { to: '/', label: 'Overview', end: true, standout: true },
  { to: '/dapps', label: 'My dApps', end: false },
  { to: '/policies', label: 'My Policies', end: false },
];

/** Grouped under a "Settings" heading. */
const SETTINGS_ITEMS = [
  { to: '/client', label: 'Account Details' },
  { to: '/billing', label: 'Billing' },
];

const Sidebar: React.FC<SidebarProps> = ({ open, onClose }) => {
  return (
    <aside className={`dashboard-sidebar ${open ? 'open' : ''}`}>
      <nav className="dashboard-sidebar-nav">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              [
                'dashboard-nav-link',
                item.standout ? 'dashboard-nav-link-standout' : '',
                isActive ? 'active' : '',
              ]
                .filter(Boolean)
                .join(' ')
            }
            onClick={onClose}
          >
            {item.label}
          </NavLink>
        ))}
        <div className="dashboard-nav-group" role="group" aria-labelledby="nav-settings">
          <div id="nav-settings" className="dashboard-nav-group-title">
            Settings
          </div>
          {SETTINGS_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => ['dashboard-nav-link', 'dashboard-nav-sublink', isActive ? 'active' : ''].filter(Boolean).join(' ')}
              onClick={onClose}
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;
